export interface ColumnPinConfig {
  columnId: string;
  parentLabel?: string;
  childLabel?: string;
}

export interface PersistedColumnConfig {
  visibility: Record<string, boolean>;
  pinning: ColumnPinConfig[];
}

export interface ColumnDisplayItem {
  id: string;
  label: string;
  isVisible: boolean;
  isPinned: boolean;
  isDisabled: boolean;
  parentGroup?: string;
  section?: string;
}

export const MAX_PINNED_COLUMNS = 3;

export const createDefaultColumnConfig = (columnIds: string[]): PersistedColumnConfig => ({
  visibility: Object.fromEntries(columnIds.map(columnId => [columnId, true])),
  pinning: [],
});
